export const SETTINGS_TABS = {
  GENERAL_INFO: 'General',
  TAX_INFO: 'Tax',
};

export const SETTINGS_TABS_LIST = {
  INDIAN_SELLER_COMMISSION: 'INDIAN SELLER COMMISSION',
  INDIAN_BUYER_COMMISSION: 'INDIAN BUYER COMMISSION',
  TASK_MANAGEMENT_SETTING: 'TASK MANAGEMENT SETTING',
  FLAG_UI: 'FLAG UI',
  CITY_MASTER: 'CITY MASTER',
};
